import { path } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';

import { HARDCODED_PAGES_WITH_ID } from '../constants';

export const useContainingIdPages = () => {
    const leaderboardPage = useAppSelector(path(['leaderboard', 'page']));

    return useMemo(() => [
        leaderboardPage,
        ...HARDCODED_PAGES_WITH_ID
    ].filter(Boolean), [leaderboardPage]);
};
